import { render } from "./switch.vue?vue&type=template&id=77e7e53d&scoped=true"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"

import "./switch.vue?vue&type=style&index=0&id=77e7e53d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e7e53d"],['__file',"src/views/vab/form/switch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77e7e53d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77e7e53d', __exports__)) {
    console.log('reload')
    api.reload('77e7e53d', __exports__)
  }
  
  module.hot.accept("./switch.vue?vue&type=template&id=77e7e53d&scoped=true", () => {
    console.log('re-render')
    api.rerender('77e7e53d', render)
  })

}


export default __exports__